export const QUERY_PARAM_KEYS = {
  PAGE: "page",
  SORTING: "ordering",
  STATUS: "status",
  IS_SHOWED_MORE: "is_showed_more",
};
